function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useCallback } from 'react';
import styled from 'styled-components';
import { palette } from '@cbhq/cds-web/tokens';
import { componentsThemeMap, colorToVariable } from '../../../componentsThemeMap.js';
import { ANALYTICS_KEY } from '../../../constants.js';
import { useOnScroll } from '../../../hooks/useOnScroll.js';
import { SlideInOut } from '../../../layout/SlideInOutContainer.js';
import { AnalyticsProvider } from '../../../providers/AnalyticsProvider.js';
import '../../../ui/Div/index.js';
import { ErrorBoundary } from '../../../ui/ErrorBoundary.js';
import '../../../ui/Link/index.js';
import { NAVBAR_SUB_NAV_HEIGHT, SUBNAV_CONTAINER_Z_INDEX } from '../constants.js';
import { SubNavSearchBar } from './SubNavSearchBar.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../../ui/Div/Div.js';
import { Link } from '../../../ui/Link/Link.js';
function SubNav({
  productName,
  productUrl,
  subNavLinks,
  hasSearch,
  searchTags,
  hasBanner,
  onSearch,
  style = 'default',
  regionDropdownCTA,
  showOnMobileOnly = false
}) {
  const colors = componentsThemeMap[style];
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "SubNav",
      children: /*#__PURE__*/jsx(SubnavContainer, {
        children: /*#__PURE__*/jsx(Div, {
          as: "nav",
          justifyContent: "center",
          width: "100%",
          background: colors.background,
          display: {
            lg: showOnMobileOnly ? 'none' : 'flex'
          },
          css: {
            borderBottom: '1px solid',
            borderColor: colorToVariable('line')
          },
          children: /*#__PURE__*/jsxs(Div, {
            zIndex: 2,
            width: "100%",
            maxWidth: 1228,
            spacingHorizontal: 3,
            height: NAVBAR_SUB_NAV_HEIGHT,
            children: [productName ? /*#__PURE__*/jsx(Div, {
              flexGrow: {
                lg: 1
              },
              flexShrink: 1,
              flexBasis: 0,
              alignItems: "center",
              spacingEnd: 3,
              css: {
                whiteSpace: 'nowrap'
              },
              children: /*#__PURE__*/jsx(Link, {
                href: productUrl || '/',
                variant: "body",
                "data-qa": ANALYTICS_KEY.ProductName,
                children: /*#__PURE__*/jsx(Div, {
                  as: "span",
                  color: colors.foreground,
                  children: productName
                })
              })
            }) : /*#__PURE__*/jsx(Div, {
              display: {
                sm: 'none',
                lg: 'block'
              },
              flex: 1
            }), /*#__PURE__*/jsx(Div, {
              flexGrow: 1,
              flexShrink: 1,
              flexBasis: 0,
              alignItems: "center",
              gap: {
                sm: 2,
                md: 4
              },
              spacingStart: {
                md: 3
              },
              spacingEnd: 3,
              spacingTop: 2,
              justifyContent: "flex-start",
              overflow: {
                sm: 'scroll',
                lg: 'visible'
              },
              overflowY: "hidden",
              css: {
                '::-webkit-scrollbar': {
                  width: 0,
                  height: 4
                },
                'scrollbar-width': 'none',
                '-ms-overflow-style': 'none',
                '&:hover': {
                  '::-webkit-scrollbar': {
                    width: '100%',
                    background: palette.primaryWash
                  },
                  'scrollbar-width': '100%',
                  '-ms-overflow-style': 'initital'
                }
              },
              children: subNavLinks.map(({
                url,
                label,
                active
              }, index) => /*#__PURE__*/jsx(Div, {
                height: "100%",
                css: {
                  span: {
                    whiteSpace: 'nowrap',
                    '&:hover': {
                      color: palette.primary
                    }
                  }
                },
                children: /*#__PURE__*/jsx(Link, {
                  href: url || '',
                  title: label,
                  variant: "label1",
                  "data-qa": `${ANALYTICS_KEY.SubNavLink}${index}`,
                  children: /*#__PURE__*/jsx(Div, {
                    as: "span",
                    color: active ? 'primary' : colors.foreground,
                    children: label
                  })
                })
              }, url || label || `sub_nav_link_index_${index}`))
            }), /*#__PURE__*/jsx(Div, {
              display: {
                sm: hasSearch ? 'block' : 'none',
                lg: 'block'
              },
              flex: {
                sm: 0,
                lg: 1
              },
              children: hasSearch && /*#__PURE__*/jsx(Div, {
                justifyContent: "flex-end",
                alignItems: "center",
                height: "100%",
                children: /*#__PURE__*/jsx(SubNavSearchBar, {
                  hasBanner: hasBanner,
                  searchTags: searchTags,
                  onSearch: onSearch
                })
              })
            }), !!regionDropdownCTA && regionDropdownCTA]
          })
        })
      })
    })
  });
}
function SubnavContainer({
  children
}) {
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  const show = useCallback(() => setVisible(false), []);
  const hide = useCallback(() => setVisible(true), []);
  useOnScroll({
    onScrollUp: hide,
    onScrollDown: show,
    disabledUp: visible,
    disabledDown: !visible
  });
  return /*#__PURE__*/jsx(SlideInOutUnderneat, {
    show: visible,
    children: children
  });
}
const SlideInOutUnderneat = styled(SlideInOut)`
  z-index: ${SUBNAV_CONTAINER_Z_INDEX};
`;
export { SubNav };
//# sourceMappingURL=SubNav.js.map
